module.exports = __webpack_public_path__ + "img/base_activites_canyoning.7a770458.svg";